import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import '../../../scss/pages/Home/MonthlyAnalytics/monthlyAnalytics.scss'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { getLocalStoreString } from '../../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux'
import { DASHBOARD_MONTHLY_CONTEST, MONTHLY_CHART_NAME, MONTHLY_PARTICULAR_CHART_DATA } from '../../../sagas/type';
import downArrow from '../../../asset/svg/downArrow.svg';
import MonthPicker from '../../../components/common/MonthPicker';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

var today = new Date();
var currentYear = today.getFullYear();
var getMonth = today.getMonth() + 1;
var currentMonth = getMonth < 9 ? '0' + getMonth : getMonth
const currentMonthYear = currentYear + '-' + currentMonth;

function monthlyAnalytics() {

    const dispatch = useDispatch()
    const { dashboardmonthlyStats, monthlyChartName, monthlyParticularChartData, } = useSelector(mapStateToProps);
    const contestId = getLocalStoreString("ContestId");
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const [selectedMonthYear, setSelectedMonthYear] = useState(currentMonthYear);
    const [graphType, setGraphType] = useState('target');
    const [graphData, setGraphData] = useState([]);
    const [attendencetriggered, setAttendencetriggered] = useState(false);
    const [value, setCalenderValue] = useState(currentMonthYear)

    useEffect(() => {
        monthlyAnalyticsData();
        getChartName();
    }, [selectedMonthYear, currentMonthYear])

    useEffect(() => {
        if (monthlyChartName && monthlyChartName.entities && monthlyChartName.entities?.length) {
            const initialType = monthlyChartName?.entities?.[0]?.chartName;
            setGraphType(initialType)
        }
    }, [monthlyChartName])

    useEffect(() => {
        if (monthlyParticularChartData && monthlyParticularChartData.entities && monthlyParticularChartData.entities?.length > 0) {
            if (monthlyParticularChartData?.entities?.[0]?.data?.length > 0) {
                const initialGraphData = monthlyParticularChartData?.entities?.[0]?.data;
                setGraphData(initialGraphData)
            }
        }
    }, [monthlyParticularChartData,])

    const monthlyAnalyticsData = () => {
        const selectedMonthYears = selectedMonthYear;
        const selectedYear = selectedMonthYears.split('-')[0];
        const selectedMonth = selectedMonthYear.split('-')[1];
        dispatch({
            type: DASHBOARD_MONTHLY_CONTEST,
            payload: { contestId, EmployeeCode, selectedYear, selectedMonth },
        });
    }

    const getMonthlyParticularChartData = (type) => {
        const selectedMonthYears = selectedMonthYear;
        const selectedYear = selectedMonthYears.split('-')[0];
        const selectedMonth = selectedMonthYear.split('-')[1];
        // const selectedType = type ? type : graphType
        dispatch({
            type: MONTHLY_PARTICULAR_CHART_DATA,
            payload: { contestId, type, EmployeeCode, selectedMonth, selectedYear, }
        })
    };

    const getChartName = () => {
        dispatch({
            type: MONTHLY_CHART_NAME,
            payload: { contestId, EmployeeCode }
        });
    };

    function CustomTooltip({ active, payload, label }) {
        const monthChange = {
            '01': 'Jan', '02': 'Feb', '03': 'Mar', '04': 'Apr', '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Aug', '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec'
        };
        const inputDateString = new Date(label);
        const formalMonth = inputDateString.getMonth();
        const monthadd = formalMonth <= 9 ? '0' + formalMonth : formalMonth
        const date = inputDateString.getDate();
        const year = inputDateString.getFullYear();
        const monthConverting = monthChange[monthadd];
        const outputDateString = `${date} ${monthConverting} ${year}`
        if (active) {
            return (
                <div style={{ borderRadius: '10px', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100px', height: '80px', backgroundColor: '#B253EC', boxShadow: ' 0px 0px 6.18128px rgba(0, 0, 0, 0.3)', flexDirection: 'column', }}>
                    <Typography>{payload?.[0].value.toFixed(2)}</Typography>
                    <Typography>{outputDateString}</Typography>
                </div>
            );
        }
        return null;
    }

    const handleClick = (type) => {
        if (type == 'attendance') {
            setAttendencetriggered(true);
            const findType = monthlyChartName?.entities.find((chartName) => chartName.chartName == type);
            setGraphType(findType.chartName);
        } else {
            setAttendencetriggered(false);
            const findType = monthlyChartName?.entities.find((chartName) => chartName.chartName == type);
            setGraphType(findType.chartName);
        }
    }

    const fetchDataByType = () => {
        getMonthlyParticularChartData(graphType);
    }

    useEffect(() => {
        if (graphType) {
            fetchDataByType()
        }
    }, [graphType])

    const tileClassName = ({ date }) => {
        var currentDate = new Date(date); var year = currentDate.getFullYear(); var month = ('0' + (currentDate.getMonth() + 1)).slice(-2); var day = ('0' + currentDate.getDate()).slice(-2); var formattedDate = year + '-' + month + '-' + day;
        const event = graphData.find((event) => event.date == formattedDate);
        // console.log(event, date, new Date(date).toISOString().slice(0, 10), new Date(date).toLocaleDateString().split("/").reverse().join("-"), "undefine");
        console.log('currentDate', formattedDate);
        if (date.getDay() == 0 || date.getDay() == 6) {
            return 'cardContainer_monthlyAnalyticsBox2_graph-container_calender-container_weekend'
        }

        if (event) {
            if (event.value == 1) {
                return 'cardContainer_monthlyAnalyticsBox2_graph-container_calender-container_presentDate';
            } else {
                return 'cardContainer_monthlyAnalyticsBox2_graph-container_calender-container_absentDate'
            }
        } else {
            return 'cardContainer_monthlyAnalyticsBox2_graph-container_calender-container_absentDate'
        }
        return '';
    }

    const handleMonthYear = (monthYear) => {
        setSelectedMonthYear(monthYear);
        setCalenderValue(monthYear);
    }

    return (
        <Box>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography padding='24px 24px 24px 0px' fontWeight='500' fontStyle='normal' fontSize='24px' lineHeight='44px' color='#FFFFFF'>Monthly Summary</Typography>
                <div style={{ color: 'white', paddingRight: '3rem' }}>
                    <MonthPicker onChange={(monthYear) => handleMonthYear(monthYear)} />
                </div>
            </div>
            <div className='cardContainer'>
                <div className='cardContainer_monthlyAnalyticsBox1'>
                    <div className='cardContainer_monthlyAnalyticsBox1_grid-container' >
                        {dashboardmonthlyStats && dashboardmonthlyStats.parameters && dashboardmonthlyStats.parameters.length > 0 && dashboardmonthlyStats.parameters.map((data) => {
                            return (
                                <div className='cardContainer_monthlyAnalyticsBox1_grid-container_grid-content' >
                                    <Typography color='#BFC7D7' textAlign='center' >{data.name}</Typography>
                                    <Typography textAlign='center' fontStyle='normal' fontWeight='700' fontSize='1.4rem' lineHeight='2rem' color='#FFFFFF'>{data.value}</Typography>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='cardContainer_monthlyAnalyticsBox2'>
                    <div className='cardContainer_monthlyAnalyticsBox2_heading-container'>
                        <Typography fontStyle='normal' fontWeight='500' fontSize='20px' lineHeight='20px' color='#FFFFFF' padding='1rem 0rem 0rem 1rem'>Highlights</Typography>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
                            {monthlyChartName && monthlyChartName.entities && monthlyChartName.entities.length > 0 && monthlyChartName.entities.map((graph) => {
                                return (
                                    <Box display='flex' alignItems='center' justifyContent='space-between' >
                                        <Typography className={graphType == graph.chartName ? 'cardContainer_monthlyAnalyticsBox2_heading-container_selected-header' : 'cardContainer_monthlyAnalyticsBox2_heading-container_header'} onClick={() => handleClick(graph.chartName)}>{graph.displayName}</Typography>
                                    </Box>
                                )
                            })}
                        </div>
                    </div>
                    <div className='cardContainer_monthlyAnalyticsBox2_graph-container'>
                        {
                            attendencetriggered ?
                                <div className='cardContainer_monthlyAnalyticsBox2_graph-container_calender-container'>
                                    <Calendar tileClassName={tileClassName} value={new Date(`${value.split('-').join('/')}/01`)} />
                                </div>
                                :
                                <ResponsiveContainer width="100%" height={300} padding='3rem 1rem 1rem 2rem'>
                                    <AreaChart width={500} height={400} data={graphData && graphData} margin={{ top: 10, right: 30, left: 0, bottom: 0, }}>
                                        <XAxis dataKey="date" />
                                        <YAxis datakey="value" />
                                        <Tooltip content={<CustomTooltip />} />
                                        <defs>
                                            <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="0%" stopColor="#B253EC" stopOpacity={0.9} />
                                                <stop offset="75%" stopColor="#B253EC" stopOpacity={0.05} />
                                            </linearGradient>
                                        </defs>
                                        <Area type="monotone" dataKey="value" stroke="#B253EC" fill="url(#color)" />
                                        <CartesianGrid opacity={0.1} vertical={false} />
                                    </AreaChart>
                                </ResponsiveContainer>
                        }
                    </div>
                </div>
            </div>
        </Box >
    )
}

const mapStateToProps = (state) => {
    return {
        dashboardmonthlyStats: state.dashboardConfig.dashboardMonthlyStatsData,
        monthlyChartName: state.dashboardConfig.dashboardMonthlyChartName,
        monthlyParticularChartData: state.dashboardConfig.dashboardMonthlyParticularChartData,
    }
}

export default monthlyAnalytics;